import { Box, Checkbox, Chip, Link, Popover, Stack, Typography } from '@mui/material';
import {
  DataGridPro,
  GridColDef,
  GridRowId,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridValueFormatterParams
} from '@mui/x-data-grid-pro';
import moment from 'moment';
import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { getPoratlHost } from 'src/components/common/hooks/useUtils';
import CustomNoRowsOverlay from 'src/components/eTMF/search/CustomNoRowsOverlay';
import SearchHierarchy from 'src/components/layouts/DashboardLayout/SearchHierarchy';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { setUserDocPermissions } from 'src/store/User';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import DocManagementService from '../documentUpload/service/DocManagementService';
import DocumentViewerComponent from '../documentViewer/DocumentViewer';
import { useDemoData } from '@mui/x-data-grid-generator';
import './tasks.scss';
import { CustomPagination } from 'src/util/DataTableFooter';
import { useGetStudiesQuery } from 'src/components/Services/Utils';

const TasksComponent = (props: any) => {
  const [rows, setTaskList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [documentToDisplayTask, setDocumentToDisplayTask] = useState<any>();
  const [dataGridComponent, setDataGridComponent] = useState(true);
  const [rejectedBy, setRejectedBy] = React.useState('');
  const [rejectReason, setRejectReason] = React.useState('');
  const [rejectOn, setRejectOn] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [page, setPage] = useState<number>(0);
  const [rowCount, setRowCount] = useState<number>(0);
  const [openVersion, setOpenVersion] = useState(false);
  const [editedFmID, setEditedFmID] = useState('');
  const SearchHierarchyDetail: any = useSelector((state: AppState) => state.searchHierarchyDetails);
  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
    id: false,
    isSelected: false
  });
  const [search, setSearch] = useState({
    Study: SearchHierarchyDetail?.data[0]?.Study,
    Country: SearchHierarchyDetail?.data[0]?.Country,
    Site: SearchHierarchyDetail?.data[0]?.Site
  });

  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const docService = new DocManagementService();
  const { checkPermission } = usePermissionWrapper();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const user: any = useAppSelector(state => state.user.user);
  const isDataAvailable: any = useAppSelector(state => state.user.user?.userdataavailable);
  const appName = 'ETMF';

  // Tasks Data Grid Columns
  const columns: GridColDef[] = [
    {
      field: 'tasks_title',
      headerName: 'Task',
      flex: 2,
      valueFormatter: params =>
        `=HYPERLINK("${getPoratlHost()}/?application=${appName}&key=${gethashedurikey(params)}", "${params.value}")`,
      renderCell: (params: any) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Typography
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              onMouseEnter={e => handlePopoverOpen(e, params.row)}
              onMouseLeave={handlePopoverClose}
              className="pwithRejectMark"
            >
              {checkPermission('view_document_details') ? (
                <Link onClick={() => gridFunc(params.row)}>{params.value!.toString()}</Link>
              ) : (
                params.value!.toString()
              )}
              {params.row.action_name === 'Reject' && <span className="rejectmark"></span>}
            </Typography>
          </div>
        );
      }
    },
    {
      field: 'due_date',
      headerName: 'Due Date',
      flex: 1,
      minWidth: 120,
      type: 'date',
      valueFormatter: (params: GridValueFormatterParams) => {
        return preferedDateFormat(params.value);
      }
    },
    {
      field: 'priority',
      headerName: 'Priority',
      flex: 1,
      type: 'singleSelect',
      valueOptions: ['High', 'Medium', 'Low']
    },
    {
      field: 'tmf_doc_status',
      headerName: 'Status',
      flex: 1,
      type: 'singleSelect',
      valueOptions: ['Uploaded', 'Ready for approval', 'Approved', 'Rejected', 'Expected']
    },
    {
      field: 'is_checked',
      headerName: 'Mark as Resolved',
      flex: 1,
      type: 'singleSelect',
      valueOptions: ['Yes', 'No'],
      renderCell: (params: any) => {
        return (
          <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <Checkbox
              checked={params?.row?.is_resolved}
              onChange={(event: any) => handleChange(event, params)}
              disabled={!checkPermission('tasks_mark_as_resolved') || params?.row?.is_resolved}
              inputProps={{
                title: 'Mark as Resolved'
              }}
            />
          </div>
        );
      }
    }
  ];

  useEffect(() => {
    if (!getAlltaskDataLoading) {
      window.scroll(0, 0);
      if (pageSize === 10 || pageSize === 20 || pageSize === 30) {
        if (page * pageSize > rowCount - 1) {
          setPage(0);

          getAllTaskData(
            SearchHierarchyDetail?.data[0]?.Study,
            SearchHierarchyDetail?.data[0]?.Country,
            SearchHierarchyDetail?.data[0]?.Site,
            0,
            pageSize
          );
        } else
          getAllTaskData(
            SearchHierarchyDetail?.data[0]?.Study,
            SearchHierarchyDetail?.data[0]?.Country,
            SearchHierarchyDetail?.data[0]?.Site,
            page * pageSize,
            pageSize
          );
      }
    }
    return () => {
      props.routeInfo(null);
    };
  }, [page, pageSize, SearchHierarchyDetail]);

  useEffect(() => {
    if (!getAlltaskDataLoading && (dataGridComponent || props.onClicked)) {
      props.routeInfo('');
      if (!dataGridComponent) {
        setDataGridComponent(true);
        getAllTaskData(
          SearchHierarchyDetail?.data[0]?.Study,
          SearchHierarchyDetail?.data[0]?.Country,
          SearchHierarchyDetail?.data[0]?.Site,
          0,
          pageSize
        );
      }
    } else {
      props.routeInfo('task');
    }
  }, [dataGridComponent, props.onClicked]);

  const gethashedurikey = (params: GridValueFormatterParams<any>) => {
    return rows.find((item: { id: GridRowId | undefined }) => item.id === params.id)?.hashed_uri_key;
  };

  /* Event Handling*/
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>, params: any) => {
    if (params.action_name === 'Reject') {
      setRejectedBy(params.rejected_by);
      setRejectReason(params.reject_reason);
      setRejectOn(params.rejected_on);
      setAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>, params: any) => {
    if (event.target.checked) {
      // const taskListCopy: any = JSON.parse(JSON.stringify(taskList));
      const found = rows.find((item: any) => params?.row?.task_id === item.task_id);
      if (found && !found.is_resolved) {
        found.is_resolved = true;
        // taskProcessingList.push({ id: params?.row?.task_id });
        const data = {
          is_resolved: found.is_resolved,
          updated_by: user?.firstName ? user?.firstName + ' ' + user.lastName : user?.lastName,
          action_name: 'create task'
        };
        const paramFields = {
          module_section_related: 'Task',
          parent_entity_related: params?.row?.tasks_title
        };
        const res: any = await docService.updateTask(
          paramFields,
          params?.row?.task_id,
          data,
          search.Study,
          search.Country,
          search.Site,
          'Study'
        );
        if (res.data) {
          //Display toast message
          store.dispatch(setSnackbarMessage('Task is marked as resolved successfully.', 'success'));
          //
        } else {
          //error
          found.is_resolved = false;
        }
        setTaskList(rows);
        getAllTaskData(search.Study, search.Country, search.Site, 0, pageSize);
      }
    }
  };

  /* Event Handling*/
  const [getAlltaskDataLoading, setGetAlltaskDataLoading] = React.useState<any>(false);

  const getAllTaskData = async (study: string, country: string, site: string, from: number, size: number) => {
    const params = {
      module_section_related: 'Tasks',
      parent_entity_related: 'TasksList'
    };
    if (study !== '--' && study !== undefined && study !== '') {
      let count = 1;
      setGetAlltaskDataLoading(true);
      const res: any = await docService.getAllTasks(study, country, site, params, from, size);
      setGetAlltaskDataLoading(false);
      const taskArray: any = [];
      if (res.error) {
        setTaskList([]);
        setLoading(true);
        // store.dispatch(setSnackbarMessage('Error in Getting Task list', 'error'));
      } else {
        setLoading(true);
        for (const data of res.data.selected_data) {
          const taskObj = {
            task_id: data.task_id,
            tasks_title: data.tasks_title,
            due_date: data.due_date,
            document_id: data.document_id,
            priority: data.priority,
            tmf_doc_status: data.tmf_doc_status,
            is_resolved: data.is_resolved,
            is_checked: data.is_resolved === false ? 'No' : 'Yes',
            id: count++,
            tmf_doc_country: data.tmf_doc_country,
            tmf_doc_site: data.tmf_doc_site,
            tmf_doc_study: data.tmf_doc_study,
            study: study,
            country: country,
            site: site,
            tmf_document_id: data.tmf_document_id,
            tmf_doc_version_number: data.tmf_doc_version_number,
            hashed_uri_key: data.hashed_uri_key,
            reject_reason: data.reject_reason,
            rejected_on: data.rejected_on,
            rejected_by: data.rejected_by,
            action_name: data.action_name
          };
          taskArray.push(taskObj);
        }
        setTaskList(taskArray);
        setSearch({ ...search, Study: study, Country: country, Site: site });
        setRowCount(res.data.record_count);
        setLoading(false);
      }
    } else {
      setTaskList([]);
      setLoading(false);
    }

    setLoading(false);
  };

  // Navigation to document viewer //
  const gridFunc = async (documentDetail: any) => {
    handlePopoverClose();
    const params = {
      module_section_related: 'DocumentDetails',
      parent_entity_related: documentDetail.tmf_document_name
    };
    const tmf_document_id = documentDetail.tmf_document_id;
    const tmf_doc_study = documentDetail.tmf_doc_study;
    const tmf_doc_version_number = documentDetail.tmf_doc_version_number;
    const result = await docService.getVersionHistory(
      tmf_document_id,
      search.Study,
      search.Country,
      search.Site,
      documentDetail.tmf_doc_level ? documentDetail.tmf_doc_level : 'Site',
      params
    );
    const latestVersionDetails = result.data[0].document_version.tmf_doc_version_number;
    const response: any = await docService.getMasterDocumentdetails(
      tmf_doc_study,
      tmf_document_id,
      latestVersionDetails,
      search.Country,
      search.Site,
      documentDetail.tmf_doc_level ? documentDetail.tmf_doc_level : 'Site',
      params
    );

    const dummyArr = [];
    dummyArr.push(response.data);
    const documentDataTotal = dummyArr.map((el: any) => {
      el.document_data.tmf_doc_latest_version = latestVersionDetails;
      el.file_master.fmId = el.file_master.id;
      el.document_data.fileId = el.file_master.id;
      el.file_master.docFormat = el.file_master.tmf_doc_type;
      el.document_data.hashed_uri_key = el.hashed_uri_key;
      el.document_data.task_Id = documentDetail.task_id;
      el.document_data.tasks_title = documentDetail.tasks_title;
      return el;
    });
    const comData = documentDataTotal.map(
      (respo: { document_data: any; file_master: any }) => [{ ...respo.file_master, ...respo.document_data }][0]
    );

    /**
     * Bharath
     */
    try {
      const response: any = await docService.getDocAccessPermissions(comData[0]);
      if (response.data != null && response.data.length > 0) {
        const docAccessPermissions: any = response.data.map((item: any) => item.permission);
        dispatch(setUserDocPermissions(docAccessPermissions));
        setDocumentToDisplayTask(comData[0]);
        setDocumentDetail(dispatch, [comData[0]]);

        setDataGridComponent(false);
      } else {
        updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
      }
    } catch (e: any) {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
    }
    /**
     * Bharath end
     */
  };

  const CustomToolbar = () => {
    const exportDateFormat = userPreferedDateFormat.includes('/')
      ? userPreferedDateFormat.replaceAll('/', '_')
      : userPreferedDateFormat.replaceAll('-', '_');
    const documentName = `TMF Tasks ` + moment(new Date()).format(`${exportDateFormat.toUpperCase()} hh_mm A`);
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarFilterButton onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarDensitySelector onResize={undefined} onResizeCapture={undefined} />
        <GridToolbarExport
          csvOptions={{
            fileName: documentName,
            allColumns: false
          }}
          disabled={!checkPermission('export_tasks_results')}
        />
      </GridToolbarContainer>
    );
  };
  const { isLoading: getStudyLoad } = useGetStudiesQuery();

  return (
    <React.Fragment>
      {dataGridComponent ? (
        <div>
          <SearchHierarchy searchData={getAllTaskData} tab="TASKS" />
          {isDataAvailable != null && isDataAvailable === false && !getStudyLoad ? (
            <div className="no-data-class">
              <h3>No Data access available!</h3>
            </div>
          ) : (
            <>
              <Box className="resultBox">
                <div style={{ height: '80vh', width: '100%' }}>
                  <DataGridPro
                    rows={rows}
                    columns={columns}
                    disableSelectionOnClick
                    rowCount={rowCount}
                    page={page}
                    onPageChange={newPage => setPage(newPage)}
                    pageSize={pageSize}
                    onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    paginationMode="server"
                    components={{
                      NoRowsOverlay: CustomNoRowsOverlay,
                      Toolbar: CustomToolbar,
                      Pagination: CustomPagination,
                      NoResultsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                          No rows
                        </Stack>
                      )
                    }}
                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel: any) => {
                      setColumnVisibilityModel(newModel);
                      const hideColumsArr: any = [];
                      for (const obj of columns) {
                        if (newModel[obj.field] == false) {
                          hideColumsArr.push(false);
                        } else {
                          hideColumsArr.push(true);
                        }
                      }
                    }}
                    className="tasks_DataGrid"
                    loading={loading}
                    getRowHeight={() => 'auto'}
                    sx={{
                      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '2px' },
                      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '6px' },
                      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '16px' }
                    }}
                  />
                </div>
              </Box>
            </>
          )}
        </div>
      ) : (
        <div>
          {documentToDisplayTask && (
            <DocumentViewerComponent
              documentDetails={documentToDisplayTask}
              props={props}
              setDataGridComponent={setDataGridComponent}
              setOpenVersion={setOpenVersion}
              setEditedFmID={setEditedFmID}
            />
          )}
        </div>
      )}

      <>
        {/* {params.row.action_name === 'Reject' && ( */}
        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: 'none'
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <Box sx={{ flexGrow: 1, p: 2 }} className="rejectPopContent">
            <Chip label="Rejected" size="small" color="error" className="topRightChip" />
            <dl>
              <dt>Rejected By:</dt>
              <dd>{rejectedBy}</dd>
            </dl>
            <h4>
              Comment <span className="commented-date">on {preferedDateFormat(rejectOn)}</span>
            </h4>
            <p>{rejectReason}</p>
          </Box>
        </Popover>
        {/* )} */}
      </>
    </React.Fragment>
  );
};

export default memo(TasksComponent);
